import React from 'react'
import './icon.css'

const Icon = (props) => {

  const handleClick = (event) => {
    event.stopPropagation()
    if (!props.disabled && props.action) props.action()
  }

  const disabled = props.disabled === true ? 'disabled' : ''
  const clickable = props.clickable ? 'clickable' : ''
  const size = props.small ? 'small' : ''
  const decorator = props.decorator ? <Icon className="decorator" icon={props.decorator} /> : ''
  const badge = props.badge ? <div className="badge">{props.badge}</div> : ''
  return (
    <span id={props.id} title={props.tooltip} className={`icon ${clickable} ${disabled} ${size} ${props.className}`} onClick={handleClick}>
      <span className="material-icons">{props.icon}</span>
      {props.src ? <img className="icon-png" src={props.src} onError={(e) => { e.target.className = "icon-png error" }} /> : ''}
      {badge}
      {decorator}
    </span>
  )
}


export default Icon




// WEBPACK FOOTER //
// ./src/lib/components/icon.js